<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @keydown.esc="closeDialog"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="toggleNavigationDrawer()">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
          <v-toolbar-title>Editar operador</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark icon @click="this.closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <h2
          class="d-flex justify-center ma-4"
          :style="showNavigation ? 'padding-left: 56px' : 'padding-left: 0px'"
        >
          <b v-if="nameItem === ''"> Unidades de negocio</b>
          <b v-else> {{ nameItem }}</b>
          <span>&nbsp;</span>|<span>&nbsp;</span>
          <b style="color: #2962ff" class="text-uppercase">{{ itemName.nombre }}</b>
        </h2>
        <Navegation
          v-if="dialog"
          :showNavigationDrawer="showNavigation"
          @nameItem="nameItemNav"
          :style="showNavigation ? 'padding-left: 56px' : 'padding-left: 0px'"
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
import Navegation from "../commons/Navigation.vue";
import businessUnits from "@/store/unidadesDeNegocios/businessUnits";
import modelsLiquidations from "@/store/modelosDeLiquidacion/modelsLiquidation";

export default {
  components: { Navegation },
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      showNavigation: true,
      nameItem: "",
    };
  },
  methods: {
    toggleNavigationDrawer() {
      this.showNavigation = !this.showNavigation;
    },
    closeDialog() {
      this.$emit("closeEditDialog");
    },
    nameItemNav(datos) {
      this.nameItem = datos;
    },
  },

  computed: {
    itemName() {
      return businessUnits.state.edit;
    },
    item() {
      return modelsLiquidations.state.edit;
    },
  },
};
</script>
<style>
.v-toolbar__content {
  margin: 0;
}
</style>